import React, { useState } from 'react';
import { UploadLookContextType } from './types/UploadLookContextType';

export const UploadLookContext =
  React.createContext<UploadLookContextType | null>(null);

type UploadLookProviderProps = {
  children: React.ReactNode;
};

const UploadLookProvider: React.FC<UploadLookProviderProps> = ({
  children,
}) => {
  const [showUploadLook, setShowUploadLook] = useState(false);
  const saveShowUploadLook = (show: boolean) => {
    setShowUploadLook(show);
  };
  return (
    <UploadLookContext.Provider value={{ showUploadLook, saveShowUploadLook }}>
      {children}
    </UploadLookContext.Provider>
  );
};

export default UploadLookProvider;
